import React, { useRef, useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import SatDataGrid from '@components/common/satUI/SatDataGrid';
import SatModal from '@components/common/satUI/SatModal';
import SatPagination from '@components/common/satUI/SatPagination';

import {
    getProdListPop,
    prdtSearchByChannelPop,
    editProdGroupMapping,
    getSaleProdList,
    getProdListPopClear
} from '@store/actions/managementProductAction';

import { showModal } from '@store/actions/commonAction';

const PrdtModifyPop = (props) => {
    const {isOpen, onClose, searchData, channelOptionData, prdtCodeOptionData} = props;
    
    const { 
        popList,
        popRows,
        popTargetRow,
        popPrdtCodeList,
    } = useSelector(state => state.managementProductReducer);

    const dispatch = useDispatch();

    const popColumns = [
        { title : '채널', key:'orgChnlNm', dataIndex : 'orgChnlNm', width : '15%' },
        { title : '상품코드', key:'saleProdCd', dataIndex : 'saleProdCd', width : '15%' },
        { title : '상품명', key:'saleProdNm', dataIndex : 'saleProdNm', width : '40%' },
        { title : '상품군', key:'saleProdGrpNm', dataIndex : 'saleProdGrpNm', width : '15%' },
        { title : '상품군 변경', key : '', dataIndex : '', render : (value, row) => (
            <>
                <div className='sel-group'>
                    <select onChange={(e) => onPrdtChange(e, row)}>
                        <option value=''>상품군 선택</option>
                        {gridPrdtList.map((item, index)=>(
                            <option
                                key={`popPrdtCodeChange_${index}`}
                                value={item.saleProdGrpCd}
                            >{item.saleProdGrpNm}
                            </option>
                        ))}
                    </select>
                </div>
            </>
        )}
    ]

    const [popGrid, setPopGrid] = useState([]);
    const [popSearchVal, setPopSearchVal] = useState({
        popChannel : '',
        popPrdt : '',
        popVal : '',
    });
    const [changeSel, setChangeSel] = useState([]);
    const [gridPrdtList, setGridPrdtList] = useState([]);


    useEffect(() => {
        setPopSearchVal({
            popChannel : searchData.channel,
            popPrdt : searchData.prdt,
            popVal : searchData.val,
        });

        dispatch(prdtSearchByChannelPop({
            orgChnlCd : searchData.channel
        }))
    }, [searchData])

    useEffect(()=>{
        let tmp = [...popList];

        tmp.forEach((item)=>{
            item.orgChnlNm = channelOptionData.filter(cd => cd.cdVal === item.orgChnlCd)[0].cmnCdNm;
          })
        setPopGrid(tmp);
    }, [popList])

    const onPrdtChange = (e, row) => {
        const {value} = e.target;
        console.log(row)
        
        row['saleProdGrpCd'] = value;
        let temp = [...changeSel];
        temp.push(row);

        setChangeSel(temp);
        // temp.push({
            // row['saleProdGrpCd'] : value
            // changePrdt : value,
        // });
        // setChangeSel(temp);
    }

    const onPopOptionChange = (e) => {
        const {name, value} = e.target;

        setPopSearchVal({
            ...popSearchVal,
            [name] : value
        })

        if(name === 'popChannel'){
            dispatch(prdtSearchByChannelPop({
                orgChnlCd : value
            }))
        }
    }

    const onPopChange = (e) => {
        const {value} = e.target;

        setPopSearchVal({
            ...popSearchVal,
            ['popVal'] : value
        })
    }

    const onPopKeyDown = (e) => {
        if(e.keyCode === 13){
            onPopSearch()
        }
    }

    const onPopSearch = () => {
        if(popSearchVal.popChannel.trim() === ''){
            dispatch(showModal({
                visible : true,
                type    : 'info',
                msg     : '채널을 선택해주세요.',
            }))

            return;
        }
        
        setGridPrdtList(popPrdtCodeList);
        dispatch(getProdListPop(popSearchVal))
    }

    const onSave = () => {
        let savePopList = [...popList];

        changeSel.forEach((item) => {
            savePopList[item.rowIndex].saleProdGrpCd = item.saleProdGrpCd
        })

        dispatch(editProdGroupMapping({
            savePopList,
            popSearchVal
        }))
    }
    return (
        <>
            <SatModal visible={isOpen} type='newInfo2'>
                <h3 className='layer-tit2'>상품군 수정</h3>
                <div className='cont'>
                    <div className='modal-tbl'>
                        <div className='search-box pop-search'>
                            <div className='data-group-left'>
                                <div className='data-area'>
                                    <div className='sel-group'>
                                        <select name='popChannel' value={popSearchVal.popChannel} onChange={onPopOptionChange}>
                                            <option value=''>전체</option>
                                            {channelOptionData.map((item, index) => (
                                                <option
                                                    key={`popCommonCodeDtl_${index}`}
                                                    value={item.cdVal}
                                                >{item.cmnCdNm}</option>
                                            ))}
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div className='data-group-left'>
                                <div className='data-area'>
                                    <div className='sel-group'>
                                        <select name='popPrdt' value={popSearchVal.popPrdt} onChange={onPopOptionChange}>
                                            <option value=''>전체</option>
                                            {popPrdtCodeList.map((item, index)=>(
                                                <option
                                                    key={`popPrdtCode_${index}`}
                                                    value={item.saleProdGrpCd}
                                                >{item.saleProdGrpNm}
                                                </option>
                                            ))}
                                            {/* {prdtCodeOptionData.map((item, index)=>(
                                                <option
                                                    key={`popPrdtCode_${index}`}
                                                    value={item.saleProdGrpCd}
                                                >{item.saleProdGrpNm}
                                                </option>
                                            ))} */}
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div className='data-group-left'>
                                <div className='data-area'>
                                    <div className='input-wrap'>
                                        <input
                                            type='text'
                                            id='text1'
                                            className='input'
                                            placeholder='상품명 입력'
                                            value={popSearchVal.popVal}
                                            onChange={onPopChange}
                                            onKeyDown={onPopKeyDown}
                                        />
                                    </div>
                                </div>
                            </div>
                            <button className='btn-search' onClick={onPopSearch}>검색</button>
                        </div>
                        <div className='table-wrap-reg pdt-0'>
                            <div className='tit-mini'>전체 {popRows}건</div>
                            <div className='table-wrap mgb-0'>
                                <SatDataGrid
                                    columns={popColumns}
                                    dataSource={popGrid}
                                    noDataRender={'검색결과가 없습니다.'}
                                />
                            </div>
                        </div>
                        {/* 페이징 */}
                        {popRows > 10 && 
                            <SatPagination
                                totalCount={popRows}
                                onChange={(index) => {
                                    dispatch(getProdListPop({
                                        ...popSearchVal,
                                        targetRow : index*10 + 1
                                    }))
                                }}
                            />
                        }
                    </div>
                </div>
                <div className='btn-area btn-area-r'>
                    <button className='btn-m save' onClick={onSave}>저장</button>
                </div>
                <button className='btn-layer-close modal-close' onClick={() => {
                    dispatch(getProdListPopClear())
                    onClose()
                }}>창닫기
                </button>
            </SatModal>
        </>
    )
}

export default PrdtModifyPop;